
export function lightenButtonInteractions(element) {
    // Get the current background color
    
    let color = '';

    if(!!element.style.backgroundColor) {
        color = element.style.backgroundColor;
    } else if(!!window.getComputedStyle(element).backgroundColor) {
        color = window.getComputedStyle(element).backgroundColor;
    } else {
        color = "rgb(255, 255, 255)";
    }
    
    // Extract the RGB components
    let [r, g, b] = color.match(/\d+/g).map(Number);

    element.addEventListener('mouseout', e => adjustBrightness(element, r, g, b));
    element.addEventListener('mouseover', e => adjustBrightness(element, r+15, g+15, b+15));
    element.addEventListener('mousedown', e => adjustBrightness(element, r+30, g+30, b+30));
    element.addEventListener('mouseup', e => adjustBrightness(element, r, g, b));
}

export function darkenButtonInteractions(element) {
    // Get the current background color

    let color = '';

    if(!!element.style.backgroundColor) {
        color = element.style.backgroundColor;
    } else if(!!window.getComputedStyle(element).backgroundColor) {
        color = window.getComputedStyle(element).backgroundColor;
    } else {
        color = "rgb(255, 255, 255)";
    }
    
    
    // Extract the RGB components
    let [r, g, b] = color.match(/\d+/g).map(Number);

    element.addEventListener('mouseout', e => adjustBrightness(element, r, g, b));
    element.addEventListener('mouseover', e => adjustBrightness(element, r-20, g-20, b-20));
    element.addEventListener('mousedown', e => adjustBrightness(element, r-40, g-40, b-40));
    element.addEventListener('mouseup', e => adjustBrightness(element, r, g, b));
}


function adjustBrightness(element, r, g, b) {

    // Apply the new color to the element
    element.style.backgroundColor = `rgb(${r}, ${g}, ${b})`;
}

export function lightenButtonInteractionsText(element) {
    // Get the current background color
    
    let color = '';

    if(!!element.style.color) {
        color = element.style.color;
    } else if(!!window.getComputedStyle(element).color) {
        color = window.getComputedStyle(element).color;
    } else {
        color = "rgb(255, 255, 255)";
    }
    
    // Extract the RGB components
    let [r, g, b] = color.match(/\d+/g).map(Number);

    element.addEventListener('mouseout', e => adjustBrightnessText(element, r, g, b));
    element.addEventListener('mouseover', e => adjustBrightnessText(element, r+15, g+15, b+15));
    element.addEventListener('mousedown', e => adjustBrightnessText(element, r+50, g+50, b+50));
    element.addEventListener('mouseup', e => adjustBrightnessText(element, r, g, b));
}

export function darkenButtonInteractionsText(element) {
    // Get the current background color

    let color = '';

    if(!!element.style.color) {
        color = element.style.color;
    } else if(!!window.getComputedStyle(element).color) {
        color = window.getComputedStyle(element).color;
    } else {
        color = "rgb(255, 255, 255)";
    }
    
    
    // Extract the RGB components
    let [r, g, b] = color.match(/\d+/g).map(Number);

    element.addEventListener('mouseout', e => adjustBrightnessText(element, r, g, b));
    element.addEventListener('mouseover', e => adjustBrightnessText(element, r-20, g-20, b-20));
    element.addEventListener('mousedown', e => adjustBrightnessText(element, r-60, g-60, b-60));
    element.addEventListener('mouseup', e => adjustBrightnessText(element, r, g, b));
}


function adjustBrightnessText(element, r, g, b) {

    // Apply the new color to the element
    element.style.color = `rgb(${r}, ${g}, ${b})`;
}

export function lightenButtonInteractionsAnotherElement(element, elementAnother) {
    // Get the current background color
    
    let color = '';

    if(!!elementAnother.style.backgroundColor) {
        color = elementAnother.style.backgroundColor;
    } else if(!!window.getComputedStyle(elementAnother).backgroundColor) {
        color = window.getComputedStyle(elementAnother).backgroundColor;
    } else {
        color = "rgb(255, 255, 255)";
    }
    
    // Extract the RGB components
    let [r, g, b] = color.match(/\d+/g).map(Number);

    element.addEventListener('mouseout', e => adjustBrightness(elementAnother, r, g, b));
    element.addEventListener('mouseover', e => adjustBrightness(elementAnother, r+15, g+15, b+15));
    element.addEventListener('mousedown', e => adjustBrightness(elementAnother, r+30, g+30, b+30));
    element.addEventListener('mouseup', e => adjustBrightness(elementAnother, r, g, b));
}

export function darkenButtonInteractionsAnotherElement(element, elementAnother) {
    // Get the current background color

    let color = '';

    if(!!elementAnother.style.backgroundColor) {
        color = elementAnother.style.backgroundColor;
    } else if(!!window.getComputedStyle(elementAnother).backgroundColor) {
        color = window.getComputedStyle(elementAnother).backgroundColor;
    } else {
        color = "rgb(255, 255, 255)";
    }
    
    
    // Extract the RGB components
    let [r, g, b] = color.match(/\d+/g).map(Number);

    element.addEventListener('mouseout', e => adjustBrightness(elementAnother, r, g, b));
    element.addEventListener('mouseover', e => adjustBrightness(elementAnother, r-20, g-20, b-20));
    element.addEventListener('mousedown', e => adjustBrightness(elementAnother, r-40, g-40, b-40));
    element.addEventListener('mouseup', e => adjustBrightness(elementAnother, r, g, b));
}

export function lightenButtonInteractionsAnotherElementText(element, elementAnother) {
    // Get the current background color
    
    let color = '';

    if(!!elementAnother.style.backgroundColor) {
        color = elementAnother.style.backgroundColor;
    } else if(!!window.getComputedStyle(elementAnother).backgroundColor) {
        color = window.getComputedStyle(elementAnother).backgroundColor;
    } else {
        color = "rgb(255, 255, 255)";
    }
    
    // Extract the RGB components
    let [r, g, b] = color.match(/\d+/g).map(Number);

    element.addEventListener('mouseout', e => adjustBrightnessText(elementAnother, r, g, b));
    element.addEventListener('mouseover', e => adjustBrightnessText(elementAnother, r+15, g+15, b+15));
    element.addEventListener('mousedown', e => adjustBrightnessText(elementAnother, r+50, g+50, b+50));
    element.addEventListener('mouseup', e => adjustBrightnessText(elementAnother, r, g, b));
}

export function darkenButtonInteractionsAnotherElementText(element, elementAnother) {
    // Get the current background color

    let color = '';

    if(!!elementAnother.style.backgroundColor) {
        color = elementAnother.style.backgroundColor;
    } else if(!!window.getComputedStyle(elementAnother).backgroundColor) {
        color = window.getComputedStyle(elementAnother).backgroundColor;
    } else {
        color = "rgb(255, 255, 255)";
    }
    
    
    // Extract the RGB components
    let [r, g, b] = color.match(/\d+/g).map(Number);

    element.addEventListener('mouseout', e => adjustBrightnessText(elementAnother, r, g, b));
    element.addEventListener('mouseover', e => adjustBrightnessText(elementAnother, r-20, g-20, b-20));
    element.addEventListener('mousedown', e => adjustBrightnessText(elementAnother, r-60, g-60, b-60));
    element.addEventListener('mouseup', e => adjustBrightnessText(elementAnother, r, g, b));
}